export default {
  mainView: {
    name: '深圳市莱康宁医用科技股份有限公司 - 实时监护',
    onlineUser: '在线用户',
    sysSet: '系统设置',
    refresh: '刷新',
    exitFs: '退出全屏',
    fs: '全屏',
    confirmRefresh: '您确认要刷新界面？',
    refreshSuccess: '刷新成功',
    tips: '温馨提示',
    closePage: '关闭本页面',
    notUser: '暂无监护用户',
    tips1: '您没有权限使用实时监护',
    tips2: '登录已失效，请您关闭本页面，重新从管理系统中打开',
    tips3: '登录失败，请您关闭窗口，重新打开。',
  },
  userList: {
    notUser: '暂无在线用户',
    id: '编号',
    name: '姓名',
    phone: '电话',
    chat: '聊天',
    new: '新',
  },
  contactInfo: {
    contInfo: '联系信息',
    pregTel: '孕妇联系电话',
    drTel: '主治医生电话',
    hospName: '医院名称',
    hospTel: '医院电话',
    close: '关闭',
  },
  chatMessage: {
    placeholder: '请输入您要发送的消息',
    tips: '您正在和{name}沟通',
  },
  settings: {
    cm: '厘米',
    cmTips: '屏幕上1厘米对应的像素宽度',
    fhrRange: '胎心正常范围值',
    speed: '纸速',
    fhr: '胎心范围',
    bed: '床位',
    bedTips: '屏幕上可以显示的监护人数',
    alarmSet: '报警设置',
    save: '保存',
    saveSuccess: '保存成功',
    fhrAlarm: '胎心报警',
  },
  fetalMonitor: {
    fhr1: '胎心一',
    fhr2: '胎心二',
    uc: '宫缩压',
    fm: '胎动',
    fetal: '手动/自动',
    fhr1Low: '胎心1偏低',
    fhr1High: '胎心1偏高',
    fhr2Low: '胎心2偏低',
    fhr2High: '胎心2偏高',
    dueDate: '预产期',
    weeks: '孕周',
  },
}
